// Spec 30 PR 3 cleanup — FinalContinue widget.
//
// Closes the onboarding flow. One quiet line + one Continue pill
// that's a plain Link. No tool hooks, no state machine arms — the
// component renders exactly one shape regardless of widget state
// (the surrounding canvas doesn't try to flip state on it because
// the schema is marked interactive: false on the server).

import { ArrowRight } from "lucide-react";
import { Link } from "react-router";

import { Pill } from "@/components/glass";

import type { WidgetRenderProps } from "../registry";

interface FinalContinueProps {
	title: string;
	body?: string | null;
	continueLabel: string;
	continueHref: string;
}

export function FinalContinue({
	props,
}: WidgetRenderProps<FinalContinueProps>) {
	return (
		<div className="py-10 space-y-7 text-center">
			<div className="space-y-2">
				<div className="text-[24px] font-medium tracking-tight text-[var(--color-text)]">
					{props.title}
				</div>
				{props.body && (
					<div className="text-[13px] text-[var(--color-text-muted)] max-w-md mx-auto leading-relaxed">
						{props.body}
					</div>
				)}
			</div>
			<div className="flex justify-center">
				<Link to={props.continueHref}>
					<Pill className="!h-11 !px-5 !text-[14px]">
						{props.continueLabel}
						<ArrowRight className="w-4 h-4" />
					</Pill>
				</Link>
			</div>
		</div>
	);
}
